(() => {
  if (window.__giftAddLite3) return; window.__giftAddLite3 = true;

  const SECTION  = 'gift-with-product[data-variant-id]';
  const BUTTON   = 'button[data-gift-add]';
  const SELECT   = 'select[data-gift-variant]';
  const ROOT     = (window.Shopify?.routes?.root || '/');

  const q = (sel, ctx=document) => ctx.querySelector(sel);

  function section(el){ return el.closest(SECTION); }
  function variantId(el){
    const s = section(el);
    const sel = s && s.querySelector(SELECT);
    return (sel && sel.value) || s?.dataset.variantId || el.dataset.variantId || '';
  }
  function props(el){
    try { return JSON.parse(section(el)?.dataset?.properties || el.dataset.properties || '{}'); }
    catch { return {}; }
  }
  function lock(btn, on){
    btn.disabled = !!on;                      // disable while working
    btn.setAttribute('aria-busy', on ? 'true' : 'false'); // no label change -> no layout shift
  }
  function updateBadge(count){
    document.querySelectorAll('[data-cart-count], .Header__CartCount, .header__cart-count, [data-header-cart-count]')
      .forEach(el => { el.textContent = String(count); el.hidden = !count; el.classList.toggle('is-empty', !count); });
  }
  function openDrawer(cart){
    const btn =
      q('[data-action="open-drawer"][href="#cart"]') ||
      q('[data-open-drawer="cart"]') ||
      q('a[href="#cart"], button[href="#cart"]');
    if (btn) btn.click();
    document.dispatchEvent(new CustomEvent('cart:open',    { detail:{cart} }));
    document.dispatchEvent(new CustomEvent('cart:refresh', { detail:{cart} }));
    document.dispatchEvent(new CustomEvent('cart:updated', { detail:{cart} }));
    try { window.Prestige?.Cart?.refresh?.(); } catch {}
  }

  async function addGift(btn){
    const id = variantId(btn); if (!id) return;
    const body = { items: [{ id: Number(id), quantity: 1, properties: props(btn) }] };

    // remember initial label (we keep it throughout)
    const labelEl = btn.querySelector('[data-gift-add-label]');
    const initial = labelEl ? labelEl.textContent : null;

    lock(btn, true);
    try {
      // Add
      const res = await fetch(ROOT + 'cart/add.js', {
        method:'POST',
        headers:{ 'Content-Type':'application/json', Accept:'application/json', 'X-Requested-With':'XMLHttpRequest' },
        body: JSON.stringify(body),
        credentials:'same-origin',
        cache:'no-store'
      });
      if (!res.ok) throw new Error('Add failed');

      // Refresh cart + UI
      const cartRes = await fetch(ROOT + 'cart.js', { headers:{ Accept:'application/json' }, cache:'no-store', credentials:'same-origin' });
      const cart = await cartRes.json().catch(() => ({}));
      updateBadge(cart.item_count || 0);
      openDrawer(cart);

      btn.disabled = true;
      btn.removeAttribute('aria-busy');
      btn.classList.add('is-added'); // (optional hook)
    } catch (e){
      console.error('[GIFT ADD]', e);
      alert('Kunne ikke tilføje gave til kurven. Prøv igen.');
      // restore original label and unlock
      if (labelEl && initial != null) labelEl.textContent = initial;
      lock(btn, false);
    }
  }

  // Click handler (delegated)
  document.addEventListener('click', (ev) => {
    const btn = ev.target.closest?.(BUTTON);
    if (!btn || !btn.matches(BUTTON)) return;
    addGift(btn);
  }, true);

  // Keep section dataset in sync with the select
  document.addEventListener('change', (ev) => {
    const sel = ev.target.closest?.(SELECT); if (!sel) return;
    const s = section(sel); if (s) s.dataset.variantId = sel.value || '';
  }, true);

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll(BUTTON).forEach(btn => {
      const label = btn.querySelector('[data-gift-add-label]');
      if (label) label.textContent = (btn.dataset.addText || 'Tilføj gave');
    });
  });
})();